import { motion } from 'framer-motion';
import * as React from 'react';

export default function FadeIn({ children, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        /* type: 'spring',
      stiffness: 260,
      damping: 20, */
        duration: 0.3,
        delay: delay * 0.1,
      }}
    >
      {children}
    </motion.div>
  );
}
